import { render } from "./AdminSurveyList.vue?vue&type=template&id=6fe90b7a&scoped=true"
import script from "./AdminSurveyList.vue?vue&type=script&lang=js"
export * from "./AdminSurveyList.vue?vue&type=script&lang=js"

import "./AdminSurveyList.vue?vue&type=style&index=0&id=6fe90b7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe90b7a"]])

export default __exports__